import { createFeature, createReducer, on } from '@ngrx/store';
import * as SchedulesActions from './schedules.actions';
import { SchedulesTypes } from '@mode/shared/contract-common';

export interface SchedulesState {
  schedules: SchedulesTypes.Schedule[] | [];
}

export const schedulesInitialState: SchedulesState = {
  schedules: [],
};

export const schedulesFeature = createFeature({
  name: 'schedules',
  reducer: createReducer(
    schedulesInitialState,
    on(SchedulesActions.loadSchedulessSuccess, (state, action) => ({
      ...state,
      schedules: action.schedules,
    }))
  ),
});
